/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrantsListResponse } from '../../models/grants-list-response';

export interface GetGrants$Params {
}

export function getGrants(http: HttpClient, rootUrl: string, params?: GetGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<GrantsListResponse>> {
  const rb = new RequestBuilder(rootUrl, getGrants.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrantsListResponse>;
    })
  );
}

getGrants.PATH = '/api/v1/grants';
